import React from 'react';
import { Pie, Bar, Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart, registerables } from 'chart.js';

// Register all necessary components
Chart.register(...registerables, ChartDataLabels);

const ChartToggle = ({ chartType, setChartType, getData, xTitle, yTitle }) => {
    const chartOptions = {
        plugins: {
            legend: {
                display: true,
                position: 'top',
                align: 'start',
                labels: {
                    boxWidth: 20,
                    padding: 10,
                },
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        const label = tooltipItem.label || '';
                        const count = tooltipItem.raw;
                        return `${label}: ${count}`;
                    },
                },
            },
            datalabels: {
                color: '#fff',
                formatter: (value, context) => {
                    const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                    return chartType === 'pie' ? `${((value / total) * 100).toFixed(1)}%` : value;
                },
            },
        },
        layout: {
            padding: {
                left: 10,
                right: 10,
                top: 10,
                bottom: 10,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: xTitle,
                },
            },
            y: {
                title: {
                    display: true,
                    text: yTitle,
                },
            },
        },
    };

    return (
        <div>
            <button onClick={() => setChartType('pie')}>Pie Chart</button>
            <button onClick={() => setChartType('bar')}>Bar Chart</button>
            <button onClick={() => setChartType('line')}>Line Chart</button>

            {chartType === 'line' && (
                <Line 
                    data={getData()} 
                    options={chartOptions} 
                />
            )}
            {chartType === 'pie' && (
                <Pie 
                    data={getData()} 
                    options={chartOptions} 
                />
            )}
            {chartType === 'bar' && (
                <Bar 
                    data={getData()} 
                    options={chartOptions} 
                />
            )}
        </div>
    );
};

export default ChartToggle;